<template>
  <div class="contract-lease-item-bd flow">
    <div class="aside">
      <div class="title">
        <i class="icon icon-yonghu2"></i>
        <span v-if="type === 'add'">
          {{ $t('crm_contract_lease_item.xzzlfa') }}
          <!-- <span v-if="productCode">({{ productCode }})</span> -->
        </span>
        <span v-if="type === 'edit'">
          {{ $t('crm_contract_lease_item.bjzlfa') }}
          <!-- <span v-if="productCode">({{ productCode }})</span> -->
        </span>
        <span v-if="type === 'watch'">
          {{ $t('crm_contract_lease_item.ckzlfa') }}
          <!-- <span v-if="productCode">({{ productCode }})</span> -->
        </span>
        <br>
        <span v-if="productCode" style="font-size: 12px; line-height: 26px; padding-left: 24px;">({{ productCode }})</span>
      </div>
      <t-step v-model="step" :list="stepList" @change="changeStep"></t-step>
    </div>
    <div class="section">
      <lease-item-step-base
        v-if="step === 0"
        :dialog="dialog"
        :goodsId="goodsId"
        :customerId="customerId"
        :categoryId="categoryId"
        :orgId="orgId"
        @cancel="onCancel"
        @step="onStep"
        @onProductCode="onProductCode"
      ></lease-item-step-base>
      <lease-item-step-manage
        v-if="step === 1"
        :dialog="dialog"
        :goodsId="goodsId"
        :productCode="productCode"
        :categoryId="categoryId"
        @cancel="onCancel"
        @back="onBack"
        @step="onStep"
        @success="onSyncList"
      ></lease-item-step-manage>
    </div>
  </div>
</template>

<script>
// import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
import leaseItemStepBase from './children/lease_item_step_base';
import leaseItemStepManage from './children/lease_item_step_manage';

const i18n = {};
const funcView = {};

export default {
  name: 'contract_lease_item',
  components: { tStep, leaseItemStepBase, leaseItemStepManage },
  props: {
    dialog: [Boolean],
    oldGoodsId: [String, Number],
    customerId: [String, Number],
    oldCategoryId: [String, Number],
    orgId: [String, Number],
  },
  data() {
    return {
      translate: { i18n, funcView },
      type: 'add',
      goodsId: '',
      categoryId: '',
      step: '',
      productCode: '',
    };
  },
  computed: {
    stepList() {
      return [
        {
          label: 1,
          value: 0,
          title: this.$t('crm_contract_lease_item.ji_ben_xin_xi'),
          subTitle: this.$t('crm_contract_lease_item.txfajbxx'),
        },
        {
          label: 2,
          value: 1,
          title: this.$t('crm_contract_lease_item.zlfagl'),
          subTitle: this.$t('crm_contract_lease_item.szzlfa'),
        },
      ];
    },
  },
  mounted: function () {
    // 弹窗编辑
    if (this.dialog) {
      //   goodsSkuId: [String, Number],
      // customerId: [String, Number],
      // partyAId: [String, Number],
      this.type = 'edit';
      this.goodsId = this.oldGoodsId;
      this.categoryId = this.oldCategoryId;
    } else {
      this.type = this.getJump('type') || (this.getJump('goodsId') ? 'edit' : 'add');
      this.goodsId = this.getJump('goodsId') || '';
      this.categoryId = this.getJump('categoryId') || '';
    }
    this.step = 0;
  },
  methods: {
    // 取消
    onCancel: function () {
      this.clearTagByKeep('contract_lease_item');
      this.jump('/offer/contractlease', { categoryId: this.categoryId }, true);
    },
    // 上一步
    onBack: function () {
      this.step--;
    },
    onProductCode: function (productCode) {
      this.productCode = productCode;
    },
    // 下一步
    onStep: function (data) {
      this.clearTagByKeep('contractlease');
      if (data && data.goodsId) {
        this.goodsId = data.goodsId;
      }
      this.step++;
    },
    // 变更步骤
    changeStep: function (item) {
      // 如果是合同里点击的编辑
      if (this.customerId) {
        return;
      }
      if (this.type === 'edit' || this.type === 'watch') {
        this.step = item.value;
      }
    },
    // 合同修改租赁方案
    onSyncList: function (list) {
      this.$emit('success', list);
    },
  },
};
</script>

<style lang="scss"></style>
